// Vendor
import * as React from 'react';

const RetailSectorDefs: React.FC = () => {
  const classesParagraph = 'tup-body leading-7';

  return (
    <div className="tup-slide">
      <h1 className="mb-8">Retail Sector Definitions</h1>
      <p className={classesParagraph}>
        <b>Secondhand:</b> Consumption of all used apparel. Includes both the
        Resale sector and the Thrift & Donation sector.
      </p>
      <p className={classesParagraph}>
        <b>Donation & Thrift:</b> A sector of the broader
        &lsquo;secondhand&rsquo; market that includes traditional options such
        as Goodwill, Salvation Army, and yard sales. These secondhand options
        are primarily, but not exclusively, offline.
      </p>
      <p className={classesParagraph}>
        <b>Resale:</b> A sector of the broader &lsquo;secondhand&rsquo; market
        that includes more curated product assortments, often well merchandised
        and/or higher end. Examples include thredUP and TheRealReal as well as
        upscale offline players like Buffalo Exchange. These secondhand options
        are primarily, but not exclusively, online.
      </p>
      <p className={classesParagraph}>
        <b>Secondhand Products:</b> Consumption of all used apparel, footwear,
        accessories, books, furniture, entertainment, and beauty.
      </p>
      <p className={classesParagraph}>
        <b>Department Stores:</b> A type of general retail store, wherein the
        retailer displays products within distinct departments, often located on
        separate floors, specializing in defined product areas. Examples include
        Bloomingdale&apos;s, Macy&apos;s, JCPenney, Nordstrom.
      </p>
      <p className={classesParagraph}>
        <b>Off-Price:</b> A retailer that sells items at lower prices than those
        typically charged by retail businesses. Off-price stores typically
        purchase overstocked goods or make special purchases. Examples include
        TJ Maxx, Marshalls, Ross, Burlington Coat Factory.
      </p>
      <p className={classesParagraph}>
        <b>Value Chains:</b> Value stores are a retail format that sells
        inexpensive items, at a single or limited number of price points.
        Examples include Walmart, Target, Dollar Tree.
      </p>
      <p className={classesParagraph}>
        <b>Mid-Priced Specialty:</b> Specialist clothing retailers operating in
        the middle of the market in terms of price. Not value but not premium or
        luxury. They tend to be found in malls or traditional main street
        locations. Examples include Gap, Ann Taylor, J.Crew.
      </p>
      <p className={classesParagraph}>
        <b>Fast Fashion:</b> Specialist clothing retailers with a fast stock
        turnaround and whose business models rely on selling high volumes at
        (usually) inexpensive price points. Examples include Zara, H&M, Forever
        21.
      </p>
      <p className={classesParagraph}>
        <b>Direct-to-Consumer:</b> Specialists and generalists selling clothing
        directly to the public. Primarily online only. Excludes C2C or auction
        type sites, and the online side of traditional retail businesses.
        Examples include Everlane, Warby Parker, Outdoor Voices.
      </p>
      <p className={classesParagraph}>
        <b>Sustainable Fashion:</b> Apparel that has been produced, sold, and
        distributed in such a way as to minimize, as much as possible, any
        damaging social and environmental impact. To be classified as
        sustainable, a company must reduce negative impacts at multiple stages
        of the supply chain and of the product’s lifecycle. Examples include
        Reformation, Allbirds, Eileen Fisher, Patagonia.
      </p>
      <p className={classesParagraph}>
        <b>Amazon:</b> Amazon&apos;s clothing sales in the US, stated at gross
        merchandise value.
      </p>
      <p className={classesParagraph}>
        <b>Subscription:</b> Subscription-based services for clothing. Excludes
        non-clothing elements of subscription models, and rental services.
        Examples include StitchFix and Trunk Club.
      </p>
      <p className={classesParagraph}>
        <b>Other:</b> Sales of clothing from all other sources, including
        grocers and supermarkets, drug stores, duty-free, warehouse clubs,
        variety stores, other non-clothing specialists, and convenience stores.
      </p>
    </div>
  );
};

export { RetailSectorDefs };
